import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Layout.css";
import {
  HomeOutlined,
  ControlOutlined,
  HistoryOutlined,
  LineChartOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar } from "antd";
import UserInfoModal from "./UserInfoModal";

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleAvatarClick = () => {
    setIsUserModalOpen(true);
  };

  const handleModalClose = () => {
    setIsUserModalOpen(false);
  };

  const menuItems = [
    {
      path: "/overview",
      label: "전체 로봇 운영 현황",
      icon: <HomeOutlined style={{ fontSize: "16px" }} />,
    },
    {
      path: "/control",
      label: "물류 로봇 컨트롤",
      icon: <ControlOutlined style={{ fontSize: "16px" }} />,
    },
    {
      path: "/history",
      label: "이력 조회",
      icon: <HistoryOutlined style={{ fontSize: "16px" }} />,
    },
    {
      path: "/dashboard",
      label: "운영 성과 대시보드",
      icon: <LineChartOutlined style={{ fontSize: "16px" }} />,
    },
  ];

  return (
    <div className="layout">
      {/* Header */}
      <header className="layout-header">
        <button className="hamburger-menu" onClick={toggleSidebar}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="header-title">
          <div className="header-title-group">
            <div className="header-logo">
              <img src="/assets/client_horizontal_logo.png" alt="RAEMIAN" />
            </div>
            <p>원페를라 물류로봇 운영 시스템</p>
          </div>
          <Avatar
            size={40}
            className="header-avatar"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.25)",
              color: "#fff",
              cursor: "pointer",
            }}
            icon={<UserOutlined />}
            onClick={handleAvatarClick}
          />
        </div>
      </header>

      <div className="layout-body">
        {/* Sidebar */}
        <aside className={`layout-sidebar ${isSidebarOpen ? "open" : ""}`}>
          <nav className="sidebar-nav">
            {menuItems.map((item) => (
              <button
                key={item.path}
                className={`nav-item ${
                  location.pathname === item.path ? "active" : ""
                }`}
                onClick={() => {
                  navigate(item.path);
                  setIsSidebarOpen(false);
                }}
              >
                {item.icon}
                <span className="nav-label">{item.label}</span>
              </button>
            ))}
          </nav>

          {/* Footer */}
          <div className="sidebar-footer">
            <div className="powered-by-text">Powered by</div>
            <img
              src="/assets/sollink_logo.png"
              alt="SOLlink"
              className="powered-by-logo"
            />
          </div>
        </aside>

        {/* Overlay for mobile */}
        {isSidebarOpen && (
          <div className="sidebar-overlay" onClick={toggleSidebar}></div>
        )}

        {/* Main Content */}
        <main className="layout-content">{children}</main>
      </div>

      {/* User Info Modal */}
      <UserInfoModal
        isOpen={isUserModalOpen}
        onClose={handleModalClose}
        user={user}
      />
    </div>
  );
};

export default Layout;
